import {useQuery} from 'react-query';
import {getSuggestAdvertisement} from '.';

const useGetSuggestAdvertisement = (subBrandId: number) => {
  const {data, isLoading} = useQuery({
    queryKey: ['suggest-advertisement', subBrandId],
    queryFn: () => getSuggestAdvertisement(subBrandId),
    enabled: !!subBrandId,
  });

  return {data, isLoading};
};

export default useGetSuggestAdvertisement;
